webpackJsonp([8],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__(7);
  __webpack_require__(6);
}
exports.default = {
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(9),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(8),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(48);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Index = function Index(r) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
        return r(__webpack_require__(55));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Download = function Download(r) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
        return r(__webpack_require__(54));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Subscribe = function Subscribe(r) {
    return __webpack_require__.e/* require.ensure */(4).then((function () {
        return r(__webpack_require__(58));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var News = function News(r) {
    return __webpack_require__.e/* require.ensure */(6).then((function () {
        return r(__webpack_require__(56));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Charge = function Charge(r) {
    return __webpack_require__.e/* require.ensure */(7).then((function () {
        return r(__webpack_require__(53));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Talkshow = function Talkshow(r) {
    return __webpack_require__.e/* require.ensure */(3).then((function () {
        return r(__webpack_require__(59));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Speech = function Speech(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__(57));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var University = function University(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(60));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

_vue2.default.use(_vueRouter2.default);
var route = new _vueRouter2.default({
    mode: 'history',
    routes: [{
        path: '/pc',
        name: 'Index',
        component: Index
    }, {
        path: '/pc/download',
        name: 'Download',
        component: Download
    }, {
        path: '/pc/charge',
        name: 'Charge',
        component: Charge
    }, {
        path: '/pc/news',
        name: 'News',
        component: News
    }, {
        path: '/pc/subscribe',
        name: 'Subscribe',
        component: Subscribe
    }, {
        path: '/pc/talkshow',
        name: 'Talkshow',
        component: Talkshow
    }, {
        path: '/pc/speech',
        name: 'Speech',
        component: Speech
    }, {
        path: '/pc/university',
        name: 'University',
        component: University
    }]
});
route.beforeEach(function (to, from, next) {
    window.scrollTo(0, 0);
    next();
});
exports.default = route;

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(25)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(42),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(16);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(14);

var _router2 = _interopRequireDefault(_router);

var _vueAwesomeSwiper = __webpack_require__(2);

var _vueAwesomeSwiper2 = _interopRequireDefault(_vueAwesomeSwiper);

var _vueResource = __webpack_require__(3);

var _vueResource2 = _interopRequireDefault(_vueResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

_vue2.default.use(_vueAwesomeSwiper2.default);

_vue2.default.use(_vueResource2.default);

_vue2.default.http.options.emulateJSON = true;

new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: {
    App: _App2.default
  }
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Header = __webpack_require__(41);

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__(40);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        CommonHeader: _Header2.default,
        CommonFooter: _Footer2.default
    }
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var URLTYPE = {
    igetget: {
        recordation: '京ICP备15037205号-2',
        recordcode: '京公网安备 11010502034003号',
        recordcodeUrl: 'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502034003',
        company: '得到（天津）文化传播有限公司',
        copyright: 'Copyright © 2019 All rights reserved'
    },
    igetup: {
        recordation: '津ICP备17003455号',
        recordcode: '',
        recordcodeUrl: '',
        company: '得到（天津）文化传播有限公司',
        copyright: '2019 © All Rights Reserved'
    }
};

exports.default = {
    data: function data() {
        return {
            data: {}
        };
    },
    created: function created() {
        if (/igetup/.test(window.location.host)) {
            this.data = URLTYPE.igetup;
        } else {
            this.data = URLTYPE.igetget;
        }
    }
};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = "//staticcdn.igetget.com/docker/fe-iget-official/dist/img/gzh.c221e3d.png";

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(27)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(44),
  /* scopeId */
  "data-v-245dc351",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(28)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(45),
  /* scopeId */
  "data-v-45902743",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('common-header'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('common-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot page"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ad"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.recordation)), (_vm.data.recordcode) ? _c('span', {
    staticClass: "copyright"
  }, [_vm._v(_vm._s(_vm.data.recordcode))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("出版物经营许可证  新出发津零字第V065号")]), _vm._v(" "), _c('p', [_vm._v("营业执照 91120116MA05JPR99J")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.company))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.copyright))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(36),
      "height": "88",
      "width": "88"
    }
  }), _vm._v("\n                知识就在得到\n            ")]), _vm._v(" "), _c('p', [_vm._v("客服电话: 400-0526-000")]), _vm._v(" "), _c('p', [_vm._v("邮箱: "), _c('a', {
    attrs: {
      "href": "mailto:iget@luojilab.com"
    }
  }, [_vm._v("iget@luojilab.com")])]), _vm._v(" "), _c('p', [_vm._v("联系地址: 北京市朝阳区华贸商务楼20号楼")]), _vm._v(" "), _c('div', {
    staticClass: "follow"
  }, [_c('span', [_vm._v("关注我们: ")]), _vm._v(" "), _c('a', {
    staticClass: "wb",
    attrs: {
      "href": "http://weibo.com/u/5745019302?topnav=1&wvr=6&topsug=1&is_all=1"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(37),
      "height": "88",
      "width": "88"
    }
  }), _vm._v("\n            微信扫码  关注「得到」公众号\n        ")])
}]}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header page"
  }, [_c('div', {
    staticClass: "contaner"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('router-link', {
    attrs: {
      "to": "/pc",
      "tag": "li"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Speech'
      },
      "tag": "li"
    }
  }, [_vm._v("跨年演讲")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'University'
      },
      "tag": "li"
    }
  }, [_vm._v("得到大学")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'News'
      },
      "tag": "li"
    }
  }, [_vm._v("新闻报道")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Download'
      },
      "tag": "li"
    }
  }, [_vm._v("App 下载")]), _vm._v(" "), _vm._m(2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/pc"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/join"
    }
  }, [_vm._v("校园招聘")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://qiye.igetget.com/",
      "target": "_blank"
    }
  }, [_vm._v("企业服务")])])
}]}

/***/ })
],[19]);


// WEBPACK FOOTER //
// dist/js/www.8ec61c46.js